import { Spinner } from '@heroui/react';
import React from 'react';

export interface PageLoadingProps {
  /**
   * The loading text to display below the spinner
   */
  text?: string;
  /**
   * Size of the spinner
   */
  size?: 'sm' | 'md' | 'lg';
  /**
   * Color of the spinner
   */
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'warning'
    | 'danger'
    | 'default'
    | 'current';
  /**
   * Additional CSS classes for the container
   */
  className?: string;
}

export const PageLoading: React.FC<PageLoadingProps> = ({
  text = 'Loading...',
  size = 'lg',
  color = 'primary',
  className = '',
}) => {
  return (
    <div
      className={`flex flex-col items-center justify-center min-h-[400px] gap-4 ${className}`}
    >
      <Spinner
        size={size}
        color={color}
        classNames={{
          circle1: 'border-b-current',
          circle2: 'border-b-current',
        }}
      />
      <div className="text-default-600 text-lg font-medium">{text}</div>
    </div>
  );
};

export default PageLoading;
